"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = void 0;
const utils_1 = require("../utils");
class Node {
    constructor(x, yFixed = true) {
        this.x = x,
            this.yFixed = yFixed;
    }
}
exports.Node = Node;
Node.createFixNodes = (coords) => (0, utils_1.createFixNodes)(coords);
